import React from 'react'

export default (props) => {
    const { value } = props
    return (
        <div
            style={{ height: '85vh', width: '100%', overflowY: 'scroll' }}
        >
            <pre className='p-3'>
                <br />
                {JSON.stringify(value, null, 2)}
            </pre>
        </div>
    )
}